import { render, staticRenderFns } from "./Folios.vue?vue&type=template&id=00ad77d5&scoped=true"
import script from "./Folios.vue?vue&type=script&lang=js"
export * from "./Folios.vue?vue&type=script&lang=js"
import style0 from "./Folios.vue?vue&type=style&index=0&id=00ad77d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ad77d5",
  null
  
)

export default component.exports